export const CTA_PRODUCT = {
  APP_DEFINITION_ID: '1380b703-ce81-ff05-f115-39571d94dfcd',
  SECTION_ID: 'product_page',
  SECTION_ID_IN_URL: 'product-page',
};
